import {SpinnerComponent} from "./shared/components/spinner/spinner.component";
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './services/language.service';

declare let $: any;
import { Component} from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, SpinnerComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent {
    constructor(
        private translate: TranslateService,
        private languageService: LanguageService
    ) {
        // El idioma se maneja ahora desde LanguageService
        this.translate.setDefaultLang('es');
    }
}
